import React from "react";
import styled from "@emotion/styled";
import { slide as Menu } from "react-burger-menu";
import { LanguageSelector } from "./LanguageSelector";
import { CurrencySelector } from "./CurrencySelector";
import { MenuItems } from "./MenuItems";
import { LocaleContext } from "../Context/Locale";
import { PhoneNumber } from "./PhoneNumber";

const CloseButton = styled.button`
    font-size: 2em;
`;

export class SideMenu extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            menuOpen: false
        }
    }
        
    closeMenu () {
        this.setState({menuOpen: false})
    }
    
    handleStateChange (state) {
        this.setState({menuOpen: state.isOpen})  
    }
    
    render() { 
        var styles = {
            bmBurgerButton: {
                zIndex: 'unset',
                maxWidth: '40px'
            }
        };

        return(    
            <Menu 
                key="menu"
                styles={styles}
                right 
                isOpen={this.state.menuOpen} 
                onStateChange={(state) => this.handleStateChange(state)}
                customBurgerIcon={ <img src={(this.props.searchURLBase ? this.props.searchURLBase : '') + "/assets/img/front/icons/hamburger-menu-blue1.svg"} width={this.props.mobile ? 40 : 50} height="auto" alt="icon" /> }
                className="bg-blue3 top-0 p-3 width-100"
                >
                <div className="text-right">
                    <CloseButton 
                        type="button"
                        onClick={() => this.closeMenu()}
                        className="line-height-inherit white btn-no mar-no pad-no bor-no bg-no"
                    >&times;</CloseButton>
                </div>
                { (this.props.mobile && this.props.mobileDisplayPhonenumber) &&
                     <PhoneNumber
                        height="20"
                        width="20"
                        iconColor="white"
                        searchURLBase={this.props.searchURLBase}
                        locale={this.props.locale}
                        tooltipEnabled={false}
                        showNumber={true}
                        className="mb-1"
                     />
                }
                <MenuItems mobile={this.props.mobile} menuList={this.props.menuList} />
                { this.props.mobile ? <hr className="bor-white"/> : ''}
                { this.props.mobile ?  <div><CurrencySelector className="btn btn-tertiary mt-3 btn-sm no-select-handle" mobile={this.props.mobile} currency={this.props.currency}/></div> : ''}
                { this.props.mobile ?
                    <LocaleContext.Consumer>
                        {  value => {
                                return (
                                    <LanguageSelector
                                        mobile={this.props.mobile}
                                        landingPagesIntl={this.props.landingPagesIntl}
                                        aiLandingpagesIntl={this.props.aiLandingpagesIntl}
                                        languageSelectorOptions={this.props.languageSelectorOptions}
                                        locale={value}
                                    />
                            );
                            }
                        }
                    </LocaleContext.Consumer>
                : ''}
            </Menu>
        );
    }
}
